import React from 'react';
import {useSelector} from 'react-redux';
import {sessionSelector} from 'store/auth/sessionSlice';
interface FeautureGuardProps {
    featuresKeys: string[];
    children: React.ReactNode;
}
export const FeautureGuard: React.FC<FeautureGuardProps> = ({featuresKeys, children}) => {
    const {tenantSettings, boardSettings, workspaceSettings} = useSelector(sessionSelector);
    const isAnyFeatureEnabled = React.useMemo(() => {
        if (featuresKeys.length === 0) return true;
        return featuresKeys.some(
            featureKey =>
                tenantSettings.some(setting => setting.uniqueId === featureKey && setting.value?.booleanValue) ||
                boardSettings.some(setting => setting.uniqueId === featureKey && setting.value?.booleanValue) ||
                workspaceSettings.some(setting => setting.uniqueId === featureKey && setting.value?.booleanValue),
        );
    }, [tenantSettings, boardSettings, workspaceSettings]);

    if (!isAnyFeatureEnabled) return <></>;

    return <>{children}</>;
};

export default FeautureGuard;
